<script>
import { USER_ACTION_TYPE_ADD_PENDING               } from '../model/user';
import { USER_ACTION_TYPE_BAN_PLAYER                } from '../model/user';
import { USER_ACTION_TYPE_UNBAN_PLAYER              } from '../model/user';
import { USER_ACTION_TYPE_ENFORCE_PLAYER_STATE      } from '../model/user';
import { USER_ACTION_TYPE_BLOCK_CHAT                } from '../model/user';
import { USER_ACTION_TYPE_CREATE_RESOURCE_LOG_COPY  } from '../model/user';
import { USER_ACTION_TYPE_SET_INVENTORY_ITEM_AMOUNT } from '../model/user';
import { USER_ACTION_TYPE_UNBLOCK_CHAT              } from '../model/user';
import { USER_ACTION_TYPE_SET_LEVEL                 } from '../model/user';

import UserActionInfoAddPending                   from './UserActionInfoAddPending.vue';
import UserActionInfoBanPlayer                    from './UserActionInfoBanPlayer.vue';
import UserActionInfoUnbanPlayer                  from './UserActionInfoUnbanPlayer.vue';
import UserActionInfoEnforcePlayerState           from './UserActionInfoEnforcePlayerState.vue';
import UserActionInfoBlockChat                    from './UserActionInfoBlockChat.vue';
import UserActionInfoCreateResourceLogCopy        from './UserActionInfoCreateResourceLogCopy.vue';
import UserActionInfoSetPlayerInventoryItemAmount from './UserActionInfoSetPlayerInventoryItemAmount.vue';
import UserActionInfoUnblockChat                  from './UserActionInfoUnblockChat.vue';
import UserActionInfoSetPlayerLevel               from './UserActionInfoSetPlayerLevel.vue';

export default {
  name: 'UserActionInfo',

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  render(createElement) {
    const componentType = getComponentTypeForAction(this.action);
    const data = {
      props: {
        action: this.action,
      },
    };
    return createElement(componentType, data);
  },
};

function getComponentTypeForAction(action) {
  switch(action.type) {
    case USER_ACTION_TYPE_ADD_PENDING:
      return UserActionInfoAddPending;
    case USER_ACTION_TYPE_BAN_PLAYER:
      return UserActionInfoBanPlayer;
    case USER_ACTION_TYPE_UNBAN_PLAYER:
      return UserActionInfoUnbanPlayer;
    case USER_ACTION_TYPE_ENFORCE_PLAYER_STATE:
      return UserActionInfoEnforcePlayerState;
    case USER_ACTION_TYPE_BLOCK_CHAT:
      return UserActionInfoBlockChat;
    case USER_ACTION_TYPE_CREATE_RESOURCE_LOG_COPY:
      return UserActionInfoCreateResourceLogCopy;
    case USER_ACTION_TYPE_SET_INVENTORY_ITEM_AMOUNT:
      return UserActionInfoSetPlayerInventoryItemAmount;
    case USER_ACTION_TYPE_UNBLOCK_CHAT:
      return UserActionInfoUnblockChat;
    case USER_ACTION_TYPE_SET_LEVEL:
      return UserActionInfoSetPlayerLevel;
  }
  return null;
}
</script>
